// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1zZfr","right":"styles_right__3Cx8C"};